import { render, staticRenderFns } from "./submissionVideo.vue?vue&type=template&id=2bc43588&scoped=true&"
import script from "./submissionVideo.vue?vue&type=script&lang=ts&"
export * from "./submissionVideo.vue?vue&type=script&lang=ts&"
import style0 from "./submissionVideo.vue?vue&type=style&index=0&id=2bc43588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc43588",
  null
  
)

export default component.exports